import React from "react";
import './EditProfile.css'; // for EditProfile.js

const EditProfile = () => {
  return (
    <div className="edit-profile-container">
      <h2>Edit Profile Page</h2>
      {/* Add form and functionalities as implemented earlier */}
    </div>
  );
};

export default EditProfile;
